import { IPlan } from '@reolink-cloud/interface';
import { IDuration, ISeriesItem } from './types';

export const getPlansByDuration = ( seriesList: ISeriesItem[], duration: IDuration ): IPlan[] => {

    return Object.values( seriesList ).sort(( a, b ) => {

        if ( a.products.length === 0 ) return 1;
        if ( b.products.length === 0 ) return -1;
        if ( a.products[0].seriesKey.toLocaleLowerCase().includes( 'basic' )) return 1;
        if ( b.products[0].seriesKey.toLocaleLowerCase().includes( 'basic' )) return -1;

        return a.sortOrder - b.sortOrder;
    
    }).reduce(( plans: IPlan[], seriesItem ) => {

        const matchedPlans = seriesItem.products.filter( product => {

            return product.duration.unit === duration.unit && product.duration.amount === duration.amount;

        });

        return plans.concat( matchedPlans.sort(( a, b ) => a.style['plan.sort'] - b.style['plan.sort'] ));

    }, [] );

};
